import React from 'react';

export const Footer: React.FC = () => {
    return (
        <footer className="py-8 bg-black border-t border-white/5">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row items-center justify-between">
                    <div className="flex items-center mb-4 md:mb-0">
                        <img src="/logo.jpg" alt="NyxBot" className="w-8 h-8 rounded-full mr-2" />
                        <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            NyxBot
                        </span>
                    </div>
                    <div className="flex items-center space-x-6">
                        <a 
                            href="https://x.com/nyktos_bot" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="text-gray-400 hover:text-white transition-colors"
                            aria-label="Twitter"
                        >
                            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                            </svg>
                        </a>
                        <p className="text-gray-400">
                            © 2025 NyxBot. Sleep through the spike.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};